import React from 'react';
import {IWithDisabled} from 'models';
import {AreaSelect} from './AreaSelect';

export const AreaMultiSelect = ({disabled}: IWithDisabled) => {
  return <AreaSelect selectionType="multi" disabled={disabled} />;
};
